// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useSpaceDetailQuery from './__generated__/useSpaceDetailQuery.graphql.ts';
import type { useSpaceDetailQuery$data } from './__generated__/useSpaceDetailQuery.graphql.ts';

const getEmptyResult = () => Promise.resolve({ data: null, loading: false, error: null });

type SpaceDetailQueryOptions = {
	includeSpaceTypeSettings?: boolean;
};

export const fetchSpaceDetail = async (
	spaceKey: string | null | undefined = '',
	{ includeSpaceTypeSettings = false }: SpaceDetailQueryOptions = {},
): Promise<{
	data: useSpaceDetailQuery$data | null;
	loading?: boolean;
	error?: ApolloErrorInterop | null;
}> => {
	if (spaceKey) {
		return query({
			query: useSpaceDetailQuery,
			variables: {
				spaceKey,
				includeSpaceTypeSettings,
			},
		});
	}

	return getEmptyResult();
};

export const preloadSpaceDetail = async (
	spaceKey: string | null | undefined = '',
	options?: SpaceDetailQueryOptions,
): Promise<{
	data: useSpaceDetailQuery$data | null;
	loading?: boolean;
	error?: ApolloErrorInterop | null;
}> => {
	return fetchSpaceDetail(spaceKey, options);
};
